import * as actions from "modules/actions";
import {
	ChecksumsToSaga,
	errorsManagerSaga,
	fetchBackDoorInfoSaga,
	fetchBackEndTimeSaga,
	fetchCommonLadderSaga,
	fetchContestByStateLadderSaga,
	fetchContestByStoreLadderSaga,
	fetchContestLadderSaga,
	fetchContestsSaga,
	fetchContestStatSaga,
	fetchFooterSaga,
	fetchHelpPagesSaga,
	fetchLadderSaga,
	fetchMonthByStateLadderSaga,
	fetchMonthByStoreLadderSaga,
	fetchMonthLadderSaga,
	fetchOverallLadderSaga,
	fetchOverallStateLadderSaga,
	fetchOverallStoreLadderSaga,
	fetchPrizesSaga,
	fetchRoundLadderSaga,
	fetchRoundStateLadderSaga,
	fetchRoundStoreLadderSaga,
	fetchStatesSaga,
	fetchStoresSaga,
	fetchTeamCommonLadderSaga,
	fetchTeamContestLadderSaga,
	fetchTeamMonthLadderSaga,
	getPlayingContestUsers,
	getUserWager,
	postUserLoginBackDoor,
	postUserLoginSaga,
	postUserLogoutSaga,
	postUserUpdateSaga,
	reAuthorizeUserSaga,
	requestVerifyCodeSaga,
	setPlayingContestUsers,
	setRoundStatusAction,
	setUserWager,
	termsModalAcceptSaga,
	verifyCodeSaga
} from 'modules/sagas';

import {
	deleteHerdSaga,
	fetchHerdSaga,
	joinHerdSaga,
	leaveHerdSaga,
	postChangeCaptainSaga,
	postCreateHerdSaga,
	postUpdateHerdSaga,
	removePlayerSaga,
	reviveHerdSaga
} from "modules/sagas/herds";

import {TIMINGS} from "modules/utils/trivia";

import {SagaIterator} from 'redux-saga';
import {all, debounce, takeLatest} from 'redux-saga/effects';
import { fetchEventsSaga, fetchIsBettingAllowedSaga } from 'modules/sagas/dashboard';
import { fetchContestTimesSaga } from 'apps/BWW_PLAY_HUB/modules/sagas/contest_times';

/**
 * Root saga that connect sagas with actions.
 */
export const rootSagasList = [

	/**
	 * Auth
	 */
	takeLatest(actions.postUserLogin, postUserLoginSaga),
	takeLatest(actions.postUserLogout, postUserLogoutSaga),
	takeLatest(actions.userLoginBackDoor, postUserLoginBackDoor),
	takeLatest(actions.postReAuthorizeUser, reAuthorizeUserSaga),
	takeLatest(actions.postUserUpdate, postUserUpdateSaga),
	takeLatest(actions.termsModalAccept, termsModalAcceptSaga),
	takeLatest(actions.requestVerifyCode, requestVerifyCodeSaga),
	takeLatest(actions.verifyCode, verifyCodeSaga),
	takeLatest(actions.subscribeToLiveScores, ChecksumsToSaga),
	takeLatest(actions.fetchBackDoorInfo, fetchBackDoorInfoSaga),
	/**
	 * Static
	 */
	takeLatest(actions.fetchHelpPages, fetchHelpPagesSaga),
	takeLatest(actions.fetchPrizes, fetchPrizesSaga),
	takeLatest(actions.fetchFooterJSON, fetchFooterSaga),

	takeLatest(actions.fetchStatesJSON, fetchStatesSaga),
	takeLatest(actions.fetchStoresJSON, fetchStoresSaga),
	takeLatest(actions.fetchContests, fetchContestsSaga),
	takeLatest(actions.globalError, errorsManagerSaga),

	takeLatest(actions.fetchLadder, fetchLadderSaga),
	takeLatest(actions.fetchContestLadder, fetchContestLadderSaga),
	takeLatest(actions.fetchTeamContestStoreLadder, fetchTeamContestLadderSaga),
	debounce(TIMINGS.spread_request_time, actions.fetchMonthLadder, fetchMonthLadderSaga),
	debounce(TIMINGS.spread_request_time, actions.fetchTeamMonthLadder, fetchTeamMonthLadderSaga),
	debounce(TIMINGS.spread_request_time, actions.fetchContestByStoreLadder, fetchContestByStoreLadderSaga),
	debounce(TIMINGS.spread_request_time, actions.fetchContestByStateLadder, fetchContestByStateLadderSaga),
	debounce(TIMINGS.spread_request_time, actions.fetchMonthByStateLadder, fetchMonthByStateLadderSaga),
	debounce(TIMINGS.spread_request_time, actions.fetchMonthByStoreLadder, fetchMonthByStoreLadderSaga),
	debounce(TIMINGS.spread_request_time, actions.fetchRoundLadder, fetchRoundLadderSaga),
	debounce(TIMINGS.spread_request_time, actions.fetchRoundStoreLadder, fetchRoundStoreLadderSaga),
	debounce(TIMINGS.spread_request_time, actions.fetchRoundStateLadder, fetchRoundStateLadderSaga),
	debounce(TIMINGS.spread_request_time, actions.fetchOverallLadder, fetchOverallLadderSaga),
	debounce(TIMINGS.spread_request_time, actions.fetchOverallByStateLadder, fetchOverallStateLadderSaga),
	debounce(TIMINGS.spread_request_time, actions.fetchOverallByStoreLadder, fetchOverallStoreLadderSaga),
	debounce(TIMINGS.spread_request_time, actions.fetchCommonLadder, fetchCommonLadderSaga),
	debounce(TIMINGS.spread_request_time, actions.fetchTeamCommonLadder, fetchTeamCommonLadderSaga),

	debounce(TIMINGS.spread_request_time, actions.setUserAsPlaying, setPlayingContestUsers),
	debounce(TIMINGS.spread_request_time, actions.getPlayingUsers, getPlayingContestUsers),

	takeLatest(actions.setWager, setUserWager),
	takeLatest(actions.getWager, getUserWager),
	takeLatest(actions.setRoundStatusAction, setRoundStatusAction),
	/**
	 * Utils
	 */
	takeLatest(actions.fetchBETime, fetchBackEndTimeSaga),
	takeLatest(actions.fetchContestStat, fetchContestStatSaga),

	/**
	 * Herds
	 */
	takeLatest(actions.createTeam, postCreateHerdSaga),
	takeLatest(actions.updateTeam, postUpdateHerdSaga),
	takeLatest(actions.fetchTeam, fetchHerdSaga),
	takeLatest(actions.joinToTeam, joinHerdSaga),
	takeLatest(actions.leaveFromTeam, leaveHerdSaga),
	takeLatest(actions.removePlayer, removePlayerSaga),
	takeLatest(actions.removeTeam, deleteHerdSaga),
	takeLatest(actions.reviveTeam, reviveHerdSaga),
	takeLatest(actions.changeCaptain, postChangeCaptainSaga),

	takeLatest(actions.fetchContestTimes, fetchContestTimesSaga),
	takeLatest(actions.fetchEvents, fetchEventsSaga),
	takeLatest(actions.fetchIsBettingAllowed, fetchIsBettingAllowedSaga),
];

export const rootSaga = function* (): SagaIterator {
	yield all( rootSagasList );
};

export * from './errors';
export * from "./user";
export * from './helpes';
export * from './prizes';
export * from './footer';
export * from './states';
export * from './stores';
export * from './contests_trivia';
export * from './live_score';
export * from './trivia';
export * from './trivia_ladder';
export * from './settings';
export * from './guestUser';
export * from './backdoor_info';
export * from './here_now_users';
export * from './trivia_stats';
